import { Button, Dropdown, message } from 'antd';
import { PictureOutlined, PlusOutlined } from '@ant-design/icons';
import type { Editor } from '@tiptap/react';
import type { MenuProps } from 'antd';
import { useImagePicker } from './image-picker-context';
import { useToolbarSize } from './ToolbarButton';

/** WordPress 風「插入」選單：標題／清單／引言／媒體庫圖片／表格／分隔線／YouTube。 */
export default function InsertMenu({ editor }: { editor: Editor }) {
  const picker = useImagePicker();
  const size = useToolbarSize();
  const c = () => editor.chain().focus();

  const addYoutube = () => {
    const url = window.prompt('貼上 YouTube 影片網址');
    if (!url) return;
    const ok = editor.commands.setYoutubeVideo({ src: url });
    if (!ok) message.error('無法辨識的 YouTube 網址');
  };

  const items: MenuProps['items'] = [
    { key: 'h2', label: '標題', onClick: () => c().toggleHeading({ level: 2 }).run() },
    { key: 'ul', label: '項目清單', onClick: () => c().toggleBulletList().run() },
    { key: 'ol', label: '編號清單', onClick: () => c().toggleOrderedList().run() },
    { key: 'quote', label: '引言', onClick: () => c().toggleBlockquote().run() },
    { type: 'divider' },
    ...(picker
      ? [{ key: 'img', icon: <PictureOutlined />, label: '從媒體庫挑選圖片', onClick: () => picker.openLibrary({ mode: 'insert' }) }]
      : []),
    { key: 'table', label: '表格', onClick: () => c().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run() },
    { key: 'hr', label: '分隔線', onClick: () => c().setHorizontalRule().run() },
    { key: 'yt', label: 'YouTube 影片', onClick: addYoutube },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button size={size} type="text" icon={<PlusOutlined />}>
        插入
      </Button>
    </Dropdown>
  );
}
